/**
 * 결재라인 flow 내부에서 사용하는 row id 생성기.
 * 같은 ms에 여러 row를 추가해도 충돌하지 않도록 짧은 랜덤 suffix를 붙인다.
 *
 * 서버에 그대로 전달되지는 않고 DnD/검색 슬롯 식별 용도이므로 단순 가독성 위주.
 */
const makeFlowId = (prefix: string): string => {
  const rand = Math.random().toString(36).slice(2, 8);
  return `${prefix}-${Date.now()}-${rand}`;
};

export default makeFlowId;
